/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { spendRulesRulesList } from "../funcs/spendRulesRulesList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListSpendRulesResult } from "../models/components/listspendrulesresult.js";
import {
  ListSpendRulesRequest,
  ListSpendRulesSecurity,
} from "../models/operations/listspendrules.js";
import { unwrapAsync } from "../types/fp.js";
export type SpendRulesListRulesQueryData = ListSpendRulesResult;

export function prefetchSpendRulesListRules(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSpendRulesRequest | undefined,
  security?: ListSpendRulesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSpendRulesListRulesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildSpendRulesListRulesQuery(
  client$: GramCore,
  request?: ListSpendRulesRequest | undefined,
  security?: ListSpendRulesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<SpendRulesListRulesQueryData>;
} {
  return {
    queryKey: queryKeySpendRulesListRules({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function spendRulesListRulesQueryFn(
      ctx,
    ): Promise<SpendRulesListRulesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(spendRulesRulesList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeySpendRulesListRules(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "rules", "list", parameters];
}
